export default __webpack_public_path__ + "static/media/040_tunnel.vp9.6e179c37.webm";